export const OPEN_MODAL = 'OPEN_MODAL'
export const OPEN_FRAME = 'OPEN_FRAME'
export const OPEN_MODAL_VIDEO = 'OPEN_MODAL_VIDEO'
export const OPEN_MODAL_DIALOG = 'OPEN_MODAL_DIALOG'
export const OPEN_POPUP_LOCATE_CITY = 'OPEN_POPUP_LOCATE_CITY'
export const OPEN_SUBSCRIPTION_STATUS = 'OPEN_SUBSCRIPTION_STATUS'
